import styled from 'styled-components';

const FilterOptions = styled.div`
  display: flex;
  margin: 12px 5px;
  flex-wrap: wrap;
  row-gap: 12px;
  select,
  input {
    min-width: 140px;
    height: 34px;
    background-color: #ffffff;
    border-radius: 4px;
    margin-right: 12px;
    padding: 6px;
    border: none;
    font-size: 14px;
  }

  input {
    width: 180px;
  }
`;

const Label = styled.div`
  font-size: 12px;
  margin: 3px 2px;
`;

export { FilterOptions, Label };
